import { FormTextareaField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PaymentRequestFormField } from '../schema';

export const PaymentRequestFormMessageField = () => (
    <FormTextareaField
        name={PaymentRequestFormField.Description}
        rows={1}
        label={lt(TextKey.MessageForCustomer)}
        required
    />
);
